import React from 'react';
import ReactDOM from 'react-dom';
import { applyMiddleware, compose, createStore } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { ConnectedRouter, routerMiddleware } from 'connected-react-router';
import AppLovinApp from '../components/AppLovinApp';
import Logger from './Logger';
import VerboseLogLevelUtils, { VerboseLogLevels } from './VerboseLogLevelUtils';
import { GlobalStyle } from '../themes/DefaultTheme/font_definitions';
import { createBrowserHistory } from 'history';
import FrameCollectionComponent from '../modules/FrameCollection/components/FrameCollectionComponent';
const TAG = 'ReduxAppCreator';
export default class ReduxAppCreator {
    static createApp(appName, reducer, appContent, options) {
        window['APPLOVIN_MODULE_NAME'] = appName;
        const history = options && options.appHistory ? options.appHistory : createBrowserHistory();
        const middleware = [routerMiddleware(history), thunkMiddleware];
        const enhancers = [];
        const verboseLogLevel = VerboseLogLevelUtils.getLevel();
        const enableAppLogger = verboseLogLevel === VerboseLogLevels.APP || verboseLogLevel === VerboseLogLevels.APP_AND_REDUX;
        const enableReduxLogger = verboseLogLevel === VerboseLogLevels.APP_AND_REDUX;
        if (enableAppLogger) {
            if (typeof (localStorage) !== 'undefined') {
                localStorage.setItem('debug', 'AppLovin:*');
            }
        }
        if (enableReduxLogger) {
            const { createLogger } = require('redux-logger');
            const loggerMiddleware = createLogger();
            middleware.push(loggerMiddleware);
            const devToolsExtension = window['__REDUX_DEVTOOLS_EXTENSION__']
                ? window['__REDUX_DEVTOOLS_EXTENSION__']()
                : (f) => f;
            if (typeof devToolsExtension === 'function') {
                enhancers.push(devToolsExtension);
            }
        }
        Logger.info(TAG, `Creating new Redux app ${appName}...`);
        const store = createStore(reducer, {}, compose(applyMiddleware(...middleware), ...enhancers));
        const AppComponent = options && options.appComponent ? options.appComponent : AppLovinApp;
        const children = (React.createElement(React.Fragment, null,
            React.createElement(GlobalStyle, null),
            appContent));
        return ReactDOM.render(React.createElement(Provider, { store: store },
            React.createElement(ConnectedRouter, { history: history },
                React.createElement(AppComponent, null, ((options && options.enableFrameCollection === undefined) || (options && options.enableFrameCollection)) ?
                    React.createElement(FrameCollectionComponent, { history: history }, children) :
                    children))), document.getElementById('root'));
    }
}
//# sourceMappingURL=ReduxAppCreator.js.map